import { COLORS, Mark } from "@/lib/theme";

export function Tin({ onTap, shake, size = 1 }) {
  const W = 190 * size, H = 270 * size;
  return (
    <button
      onClick={onTap}
      aria-label="Donation tin"
      className={"no-tap-highlight " + (shake ? "anim-clink" : "")}
      style={{
        position: "relative",
        width: W,
        height: H,
        border: "none",
        background: "none",
        cursor: onTap ? "pointer" : "default",
        padding: 0,
      }}
    >
      {/* metal rim top */}
      <div style={{ position: "absolute", top: 0, left: 6, right: 6, height: 30, borderRadius: "50%", background: "linear-gradient(180deg,#f4f4f6,#bdbdc4 45%,#8b8b93 55%,#e9e9ee)", zIndex: 3 }} />
      {/* slot */}
      <div style={{ position: "absolute", top: 19, left: "50%", transform: "translateX(-50%)", width: 64, height: 6, borderRadius: 6, background: "#2c2c30", zIndex: 4, boxShadow: "inset 0 1px 2px rgba(0,0,0,0.6)" }} />
      {/* body */}
      <div style={{
        position: "absolute", top: 22, left: 6, right: 6, bottom: 16, borderRadius: "13px / 24px", overflow: "hidden", zIndex: 1,
        background: "linear-gradient(90deg,rgba(0,0,0,0.5) 0%,rgba(0,0,0,0.12) 16%,rgba(255,255,255,0.22) 46%,rgba(255,255,255,0.05) 56%,rgba(0,0,0,0.16) 84%,rgba(0,0,0,0.55) 100%)," + `linear-gradient(160deg,${COLORS.plum} 0%,${COLORS.purple} 52%,#8E1F5C 100%)`,
        boxShadow: "inset 0 0 26px rgba(0,0,0,0.25)",
      }}>
        <svg viewBox="0 0 190 270" preserveAspectRatio="none" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}>
          <path d="M0,60 C60,15 110,135 190,85 L190,270 L0,270 Z" fill="rgba(255,255,255,0.07)" />
          <path d="M0,160 C80,105 120,250 190,190 L190,270 L0,270 Z" fill="rgba(216,40,140,0.28)" />
        </svg>
        <div style={{ position: "absolute", left: 0, right: 0, top: "44%", display: "flex", flexDirection: "column", alignItems: "center", gap: 5 }}>
          <Mark size={46 * size} tone="white" />
          <div className="font-heading" style={{ fontWeight: 800, fontSize: 21 * size, color: "#fff", letterSpacing: "-0.5px", textShadow: "0 1px 3px rgba(0,0,0,0.3)" }}>
            Linkshul
          </div>
        </div>
      </div>
      {/* base */}
      <div style={{ position: "absolute", bottom: 0, left: 6, right: 6, height: 22, borderRadius: "50%", background: "linear-gradient(180deg,#8b8b93,#e9e9ee 60%,#bdbdc4)", zIndex: 0 }} />
    </button>
  );
}

export function Coin({ animate, size = 96 }) {
  return (
    <div style={{ width: size, height: size, animation: animate ? "drop 1s ease-in forwards" : "bob 3s ease-in-out infinite" }}>
      <div style={{
        width: size, height: size, borderRadius: "50%",
        background: "radial-gradient(circle at 38% 32%,#fbfbfd,#cfd0d6 55%,#9a9ba2 78%,#7c7d84)",
        boxShadow: "0 8px 18px rgba(0,0,0,0.25),inset 0 0 0 5px rgba(255,255,255,0.35),inset 0 0 0 8px rgba(150,150,158,0.6)",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <div style={{ filter: "grayscale(1) opacity(0.8)" }}><Mark size={size * 0.5} tone="gold" /></div>
      </div>
    </div>
  );
}
